import { useEffect } from 'react';
import { Tag } from 'antd';
import type { ColumnsType } from 'antd/lib/table';

import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { TableService } from '../../../../service/table.service';
import type { CheckIn } from './modalDashboardSlice';
import { handleModalTableChange } from './modalDashboardSlice';

export const GetCheckInsModalProps = () => {
  const dispatch = useAppDispatch();
  const { getColumnSearchProps, clearSearch } = TableService();
  const productFilter = useAppSelector((state) => state.tableSlice.productFilter);
  const sortedInfo = useAppSelector((state) => state.modalDashboardSlice.requestModalParam.sortedInfo);
  const filteredInfo = useAppSelector((state) => state.modalDashboardSlice.requestModalParam.filteredInfo);

  useEffect(() => {
    dispatch(
      handleModalTableChange({
        sorter: {
          columnKey: 'total',
          field: 'total',
          order: 'descend',
        },
      }),
    );
  }, [dispatch]);

  const columns: ColumnsType<CheckIn> = [
    {
      title: 'Client name',
      dataIndex: 'full_name',
      key: 'full_name',
      width: 200,
      sorter: (a, b) => a.full_name.localeCompare(b.full_name),
      onFilter: (value, record) => record.full_name.toLowerCase().includes((value as string).toLowerCase()),
      ...getColumnSearchProps('full_name', filteredInfo.full_name),
      sortOrder: sortedInfo.field === 'full_name' ? sortedInfo.order : null,
      filteredValue: filteredInfo.full_name || null,
      className: 'ph-no-capture',
    },
    {
      title: 'Sites',
      dataIndex: 'sites',
      key: 'sites',
      width: 100,
      ...getColumnSearchProps('sites', filteredInfo.sites),
      onFilter: (value, record) => record.sites?.some((s) => s.toLowerCase().includes((value as string).toLowerCase())),
      render: (_text, record) =>
        record.sites?.map((site, index) => {
          return (
            <div key={index}>
              {site !== null ? (
                <Tag color="geekblue" style={{ border: 'none' }}>
                  {site}
                </Tag>
              ) : null}
            </div>
          );
        }),
      sortOrder: sortedInfo.field === 'sites' ? sortedInfo.order : null,
      filteredValue: filteredInfo.sites || null,
    },
    {
      title: 'Products',
      dataIndex: 'products',
      key: 'products',
      filters: productFilter,
      onFilter: (value, record) => record.products?.includes(value as string),
      filteredValue: filteredInfo.products || null,
      width: 100,
      render: (_text, record) =>
        record.products?.map((product, index) => {
          return (
            <div key={index}>
              {product !== null ? (
                <Tag color="geekblue" style={{ border: 'none' }}>
                  {product}
                </Tag>
              ) : null}
            </div>
          );
        }),
    },
    {
      title: 'Check-ins',
      dataIndex: 'total',
      key: 'total',
      width: 100,
      sorter: (a, b) => a.total - b.total,
      sortOrder: sortedInfo.field === 'total' ? sortedInfo.order : null,
    },
  ];

  return { columns, clearSearch };
};
